import { render, staticRenderFns } from "./FixedPlugin.vue?vue&type=template&id=5560f30a&scoped=true&"
import script from "./FixedPlugin.vue?vue&type=script&lang=js&"
export * from "./FixedPlugin.vue?vue&type=script&lang=js&"
import style0 from "./FixedPlugin.vue?vue&type=style&index=0&id=5560f30a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5560f30a",
  null
  
)

export default component.exports